<template lang="pug">
  VModal(
    :name="name"
    classes="v--modal v--modal-box p-modal"
    :width="width"
    :height="height"
    :area-da-aplicacao="areaDaAplicacao"
    @before-open="event => $emit('beforeOpen', event)"
    @before-close="$emit('beforeClose')"
    @closed="$emit('closed')"
  )
    .p-modal__content(:class="{ 'p-modal__content--scrollable': scrollContent }")
      slot
    button.p-modal__close(type="button" aria-label="Fechar modal" @click="fecharModal")
      span.icone-chapado-fechar.fs-15.fw-bold
</template>

<script>
import VModal from './VModal.vue'

export default {
  name: 'PModal',
  components: { VModal },
  emits: ['beforeOpen', 'beforeClose', 'closed'],
  props: {
    name: {type: String, required: true},
    width: {type: String, required: true},
    height: {type: String, required: true},
    areaDaAplicacao: {type: Boolean, default: false},
    scrollContent: {type: Boolean, default: false}
  },
  methods: {
    fecharModal () {
      this.$modal.hide(this.name)
    }
  }
}
</script>

<style lang="scss">
.p-modal {
  padding: 20px;
}
.p-modal__close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--color-info);
  font-size: 15px;
  line-height: 1;
}
.p-modal__content {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 25px;

  @media (max-width: 900px) {
    padding: 0;
  }
}

.p-modal__content--scrollable {
  overflow: auto;
}
</style>
